// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : REMOVED UNUSED ACTIONS
// MODIFIED DATE: 26-09-2025

import repaymentCollectionReportTypes from './repayment-collection-report.types';

/************* FETCH REPAYMENT COLLECTION REPORT START *********************** */
export const fetchPostRepaymentCollectionSuccess = (user: any) => ({
	type: repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_SUCCESS,
	payload: user,
});

export const fetchPostRepaymentCollectionFailure = (error: any) => ({
	type: repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_FAILURE,
	payload: error,
});

export const fetchPostRepaymentCollectionStart = (user: any) => ({
	type: repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_START,
	payload: user,
});

export const fetchPostRepaymentCollectionReset = () => ({
	type: repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_RESET,
});

export const fetchPostRepaymentCollectionChanged = () => ({
	type: repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_RESPONSE_CHANGED,
});
/************* FETCH REPAYMENT COLLECTION REPORT END *********************** */
